/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface AdminSeedService {
  /**
   * @summary Create Seed Service Events
   * @description Bulk seed service events for existing customers.
   *
   * Creates service events for multiple customers, auto-instantiating
   * service types (and optionally service plans) from templates.
   */
  seedServiceEvents: {
    /**
     * @summary Create Seed Service Events
     * @description Bulk seed service events for existing customers.
     *
     * Creates service events for multiple customers, auto-instantiating
     * service types (and optionally service plans) from templates.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<SeedServiceEventsBody, SeedServiceEventsParameters, TMeta, TSignal>,
      client?: (
        schema: SeedServiceEventsSchema,
        options: ServiceOperationMutationFnOptions<SeedServiceEventsBody, SeedServiceEventsParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<SeedServiceEventsData, SeedServiceEventsError>>
    ): Promise<RequestFnResponse<SeedServiceEventsData, SeedServiceEventsError>>;
    /**
     * @summary Create Seed Service Events
     * @description Bulk seed service events for existing customers.
     *
     * Creates service events for multiple customers, auto-instantiating
     * service types (and optionally service plans) from templates.
     */
    getMutationKey(
      parameters: DeepReadonly<SeedServiceEventsParameters> | void
    ): ServiceOperationMutationKey<SeedServiceEventsSchema, SeedServiceEventsParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Seed Service Events
     * @description Bulk seed service events for existing customers.
     *
     * Creates service events for multiple customers, auto-instantiating
     * service types (and optionally service plans) from templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.adminSeedService.seedServiceEvents.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.adminSeedService.seedServiceEvents.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends SeedServiceEventsBody, TContext = unknown>(
      parameters: DeepReadonly<SeedServiceEventsParameters>,
      options?: ServiceOperationUseMutationOptions<
        SeedServiceEventsSchema,
        SeedServiceEventsData,
        SeedServiceEventsParameters,
        TVariables,
        OperationError<SeedServiceEventsError>,
        TContext
      >
    ): UseMutationResult<SeedServiceEventsData, OperationError<SeedServiceEventsError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Seed Service Events
     * @description Bulk seed service events for existing customers.
     *
     * Creates service events for multiple customers, auto-instantiating
     * service types (and optionally service plans) from templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.adminSeedService.seedServiceEvents.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.adminSeedService.seedServiceEvents.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<SeedServiceEventsBody, SeedServiceEventsParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SeedServiceEventsSchema,
        SeedServiceEventsData,
        SeedServiceEventsParameters,
        TVariables,
        OperationError<SeedServiceEventsError>,
        TContext
      >
    ): UseMutationResult<SeedServiceEventsData, OperationError<SeedServiceEventsError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Seed Service Events
     * @description Bulk seed service events for existing customers.
     *
     * Creates service events for multiple customers, auto-instantiating
     * service types (and optionally service plans) from templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const seedServiceEventsTotal = qraft.adminSeedService.seedServiceEvents.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const seedServiceEventsTotal = qraft.adminSeedService.seedServiceEvents.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SeedServiceEventsBody,
            SeedServiceEventsData,
            SeedServiceEventsParameters,
            OperationError<SeedServiceEventsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SeedServiceEventsSchema,
            SeedServiceEventsBody,
            SeedServiceEventsData,
            SeedServiceEventsParameters,
            OperationError<SeedServiceEventsError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Seed Service Events
     * @description Bulk seed service events for existing customers.
     *
     * Creates service events for multiple customers, auto-instantiating
     * service types (and optionally service plans) from templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const seedServiceEventsPendingMutationVariables = qraft.adminSeedService.seedServiceEvents.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const seedServiceEventsMutationData = qraft.adminSeedService.seedServiceEvents.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SeedServiceEventsData,
        OperationError<SeedServiceEventsError>,
        MutationVariables<SeedServiceEventsBody, SeedServiceEventsParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SeedServiceEventsBody,
            SeedServiceEventsData,
            SeedServiceEventsParameters,
            OperationError<SeedServiceEventsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SeedServiceEventsSchema,
            SeedServiceEventsBody,
            SeedServiceEventsData,
            SeedServiceEventsParameters,
            OperationError<SeedServiceEventsError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SeedServiceEventsData,
          OperationError<SeedServiceEventsError>,
          MutationVariables<SeedServiceEventsBody, SeedServiceEventsParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Seed Service Events
     * @description Bulk seed service events for existing customers.
     *
     * Creates service events for multiple customers, auto-instantiating
     * service types (and optionally service plans) from templates.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SeedServiceEventsBody,
            SeedServiceEventsData,
            SeedServiceEventsParameters,
            OperationError<SeedServiceEventsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SeedServiceEventsSchema,
            SeedServiceEventsBody,
            SeedServiceEventsData,
            SeedServiceEventsParameters,
            OperationError<SeedServiceEventsError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Seed Service Events
     * @description Bulk seed service events for existing customers.
     *
     * Creates service events for multiple customers, auto-instantiating
     * service types (and optionally service plans) from templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.adminSeedService.seedServiceEvents.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.adminSeedService.seedServiceEvents.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SeedServiceEventsBody,
              SeedServiceEventsData,
              SeedServiceEventsParameters,
              OperationError<SeedServiceEventsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SeedServiceEventsSchema,
              SeedServiceEventsBody,
              SeedServiceEventsData,
              SeedServiceEventsParameters,
              OperationError<SeedServiceEventsError>,
              TContext
            >
      ):
        | Mutation<
            SeedServiceEventsData,
            SeedServiceEventsError,
            MutationVariables<SeedServiceEventsBody, SeedServiceEventsParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SeedServiceEventsBody,
              SeedServiceEventsData,
              SeedServiceEventsParameters,
              OperationError<SeedServiceEventsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SeedServiceEventsSchema,
              SeedServiceEventsBody,
              SeedServiceEventsData,
              SeedServiceEventsParameters,
              OperationError<SeedServiceEventsError>,
              TContext
            >
      ): Array<
        Mutation<
          SeedServiceEventsData,
          SeedServiceEventsError,
          MutationVariables<SeedServiceEventsBody, SeedServiceEventsParameters>,
          TContext
        >
      >;
    };
    schema: SeedServiceEventsSchema;
    types: {
      parameters: SeedServiceEventsParameters;
      data: SeedServiceEventsData;
      error: SeedServiceEventsError;
      body: SeedServiceEventsBody;
    };
  };
  /**
   * @summary Get Customers With Events
   * @description List customers with optional filtering by upcoming events in date range.
   *
   * Use has_upcoming_events=false to find customers without scheduled events
   * (ideal candidates for seeding).
   */
  listCustomersWithEvents: {
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<ListCustomersWithEventsParameters, TMeta, TSignal>,
      client?: (
        schema: ListCustomersWithEventsSchema,
        options: {
          parameters: ListCustomersWithEventsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListCustomersWithEventsData, ListCustomersWithEventsError>>
    ): Promise<RequestFnResponse<ListCustomersWithEventsData, ListCustomersWithEventsError>>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    getQueryKey(
      parameters: DeepReadonly<ListCustomersWithEventsParameters>
    ): ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.adminSeedService.listCustomersWithEvents.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListCustomersWithEventsData>(
      parameters:
        | ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        | DeepReadonly<ListCustomersWithEventsParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          ListCustomersWithEventsData,
          ListCustomersWithEventsError,
          TData,
          ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListCustomersWithEventsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.adminSeedService.listCustomersWithEvents.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListCustomersWithEventsData>(
      parameters:
        | ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        | DeepReadonly<ListCustomersWithEventsParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          ListCustomersWithEventsData,
          ListCustomersWithEventsError,
          TData,
          ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListCustomersWithEventsError>>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListCustomersWithEventsParameters>
    ): ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.adminSeedService.listCustomersWithEvents.useInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListCustomersWithEventsParameters,
      TQueryFnData = ListCustomersWithEventsData,
      TData = OperationInfiniteData<TQueryFnData, ListCustomersWithEventsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        | DeepReadonly<ListCustomersWithEventsParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListCustomersWithEventsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListCustomersWithEventsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.adminSeedService.listCustomersWithEvents.useInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListCustomersWithEventsParameters,
      TQueryFnData = ListCustomersWithEventsData,
      TData = OperationInfiniteData<TQueryFnData, ListCustomersWithEventsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        | DeepReadonly<ListCustomersWithEventsParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListCustomersWithEventsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListCustomersWithEventsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListCustomersWithEventsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listCustomersWithEventsTotal = qraft.adminSeedService.listCustomersWithEvents.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listCustomersWithEventsByParametersTotal = qraft.adminSeedService.listCustomersWithEvents.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
        | QueryFiltersByQueryKey<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listCustomersWithEventsResults = qraft.adminSeedService.listCustomersWithEvents.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listCustomersWithEventsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listCustomersWithEventsCombinedResults = qraft.adminSeedService.listCustomersWithEvents.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listCustomersWithEventsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListCustomersWithEventsSchema,
          ListCustomersWithEventsParameters,
          ListCustomersWithEventsData,
          ListCustomersWithEventsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListCustomersWithEventsData, ListCustomersWithEventsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListCustomersWithEventsData, ListCustomersWithEventsError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.adminSeedService.listCustomersWithEvents.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListCustomersWithEventsData>(
      parameters:
        | ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        | DeepReadonly<ListCustomersWithEventsParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          ListCustomersWithEventsData,
          ListCustomersWithEventsError,
          TData,
          ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListCustomersWithEventsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.adminSeedService.listCustomersWithEvents.useSuspenseInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListCustomersWithEventsParameters, TData = ListCustomersWithEventsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        | DeepReadonly<ListCustomersWithEventsParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListCustomersWithEventsData,
          ListCustomersWithEventsError,
          OperationInfiniteData<TData, ListCustomersWithEventsParameters>,
          ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListCustomersWithEventsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListCustomersWithEventsParameters>,
      OperationError<ListCustomersWithEventsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listCustomersWithEventsData = qraft.adminSeedService.listCustomersWithEvents.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listCustomersWithEventsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listCustomersWithEventsCombinedData = qraft.adminSeedService.listCustomersWithEvents.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listCustomersWithEventsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListCustomersWithEventsSchema,
          ListCustomersWithEventsParameters,
          ListCustomersWithEventsData,
          ListCustomersWithEventsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListCustomersWithEventsData, ListCustomersWithEventsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<ListCustomersWithEventsData, ListCustomersWithEventsError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListCustomersWithEventsSchema,
        ListCustomersWithEventsData,
        ListCustomersWithEventsParameters,
        ListCustomersWithEventsError
      >
    ): Promise<ListCustomersWithEventsData>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListCustomersWithEventsSchema,
        ListCustomersWithEventsData,
        ListCustomersWithEventsParameters,
        ListCustomersWithEventsError
      >
    ): Promise<void>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListCustomersWithEventsSchema,
        ListCustomersWithEventsData,
        ListCustomersWithEventsParameters,
        ListCustomersWithEventsError
      >
    ): Promise<ListCustomersWithEventsData>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    fetchInfiniteQuery<TPageParam extends ListCustomersWithEventsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListCustomersWithEventsSchema,
        ListCustomersWithEventsData,
        ListCustomersWithEventsParameters,
        DeepReadonly<TPageParam>,
        ListCustomersWithEventsError
      >
    ): Promise<OperationInfiniteData<ListCustomersWithEventsData, ListCustomersWithEventsParameters>>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    prefetchInfiniteQuery<TPageParam extends ListCustomersWithEventsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListCustomersWithEventsSchema,
        ListCustomersWithEventsData,
        ListCustomersWithEventsParameters,
        DeepReadonly<TPageParam>,
        ListCustomersWithEventsError
      >
    ): Promise<void>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    ensureInfiniteQueryData<TPageParam extends ListCustomersWithEventsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListCustomersWithEventsSchema,
        ListCustomersWithEventsData,
        ListCustomersWithEventsParameters,
        DeepReadonly<TPageParam>,
        ListCustomersWithEventsError
      >
    ): Promise<OperationInfiniteData<ListCustomersWithEventsData, ListCustomersWithEventsParameters>>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        | DeepReadonly<ListCustomersWithEventsParameters>
    ): ListCustomersWithEventsData | undefined;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        | DeepReadonly<ListCustomersWithEventsParameters>
    ): OperationInfiniteData<ListCustomersWithEventsData, ListCustomersWithEventsParameters> | undefined;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
        | QueryFiltersByQueryKey<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListCustomersWithEventsSchema,
              ListCustomersWithEventsParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<ListCustomersWithEventsData, ListCustomersWithEventsParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>,
            data: ListCustomersWithEventsData | undefined,
          ]
        >;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
        | DeepReadonly<ListCustomersWithEventsParameters>
    ): QueryState<ListCustomersWithEventsData, ListCustomersWithEventsError> | undefined;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListCustomersWithEventsParameters>
        | ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>
    ):
      | QueryState<
          OperationInfiniteData<ListCustomersWithEventsData, ListCustomersWithEventsParameters>,
          ListCustomersWithEventsError
        >
      | undefined;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    setQueryData(
      parameters:
        | DeepReadonly<ListCustomersWithEventsParameters>
        | ServiceOperationQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>,
      updater: Updater<
        NoInfer<ListCustomersWithEventsData> | undefined,
        NoInfer<DeepReadonly<ListCustomersWithEventsData>> | undefined
      >,
      options?: SetDataOptions
    ): ListCustomersWithEventsData | undefined;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<ListCustomersWithEventsParameters>
        | ServiceOperationInfiniteQueryKey<ListCustomersWithEventsSchema, ListCustomersWithEventsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListCustomersWithEventsData, ListCustomersWithEventsParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<ListCustomersWithEventsData, ListCustomersWithEventsParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListCustomersWithEventsData, ListCustomersWithEventsParameters> | undefined;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
        | QueryFiltersByQueryKey<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >,
      updater: Updater<
        NoInfer<ListCustomersWithEventsData> | undefined,
        NoInfer<ListCustomersWithEventsData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListCustomersWithEventsData | undefined>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListCustomersWithEventsSchema,
        ListCustomersWithEventsData,
        TInfinite,
        ListCustomersWithEventsParameters,
        ListCustomersWithEventsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
        | QueryFiltersByQueryKey<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
        | QueryFiltersByQueryKey<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
        | QueryFiltersByQueryKey<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
    ): void;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
        | QueryFiltersByQueryKey<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Customers With Events
     * @description List customers with optional filtering by upcoming events in date range.
     *
     * Use has_upcoming_events=false to find customers without scheduled events
     * (ideal candidates for seeding).
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
        | QueryFiltersByQueryKey<
            ListCustomersWithEventsSchema,
            ListCustomersWithEventsData,
            TInfinite,
            ListCustomersWithEventsParameters,
            ListCustomersWithEventsError
          >
    ): number;
    schema: ListCustomersWithEventsSchema;
    types: {
      parameters: ListCustomersWithEventsParameters;
      data: ListCustomersWithEventsData;
      error: ListCustomersWithEventsError;
    };
  };
  /**
   * @summary Create Seed Customers
   * @description Seed fake customers with random addresses from a region.
   *
   * Creates N customers with Faker-generated names, phone numbers, and emails,
   * using real addresses sampled from the specified region's address file.
   */
  seedCustomers: {
    /**
     * @summary Create Seed Customers
     * @description Seed fake customers with random addresses from a region.
     *
     * Creates N customers with Faker-generated names, phone numbers, and emails,
     * using real addresses sampled from the specified region's address file.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<SeedCustomersBody, SeedCustomersParameters, TMeta, TSignal>,
      client?: (
        schema: SeedCustomersSchema,
        options: ServiceOperationMutationFnOptions<SeedCustomersBody, SeedCustomersParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<SeedCustomersData, SeedCustomersError>>
    ): Promise<RequestFnResponse<SeedCustomersData, SeedCustomersError>>;
    /**
     * @summary Create Seed Customers
     * @description Seed fake customers with random addresses from a region.
     *
     * Creates N customers with Faker-generated names, phone numbers, and emails,
     * using real addresses sampled from the specified region's address file.
     */
    getMutationKey(
      parameters: DeepReadonly<SeedCustomersParameters> | void
    ): ServiceOperationMutationKey<SeedCustomersSchema, SeedCustomersParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Seed Customers
     * @description Seed fake customers with random addresses from a region.
     *
     * Creates N customers with Faker-generated names, phone numbers, and emails,
     * using real addresses sampled from the specified region's address file.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.adminSeedService.seedCustomers.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.adminSeedService.seedCustomers.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends SeedCustomersBody, TContext = unknown>(
      parameters: DeepReadonly<SeedCustomersParameters>,
      options?: ServiceOperationUseMutationOptions<
        SeedCustomersSchema,
        SeedCustomersData,
        SeedCustomersParameters,
        TVariables,
        OperationError<SeedCustomersError>,
        TContext
      >
    ): UseMutationResult<SeedCustomersData, OperationError<SeedCustomersError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Seed Customers
     * @description Seed fake customers with random addresses from a region.
     *
     * Creates N customers with Faker-generated names, phone numbers, and emails,
     * using real addresses sampled from the specified region's address file.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.adminSeedService.seedCustomers.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.adminSeedService.seedCustomers.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<SeedCustomersBody, SeedCustomersParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SeedCustomersSchema,
        SeedCustomersData,
        SeedCustomersParameters,
        TVariables,
        OperationError<SeedCustomersError>,
        TContext
      >
    ): UseMutationResult<SeedCustomersData, OperationError<SeedCustomersError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Seed Customers
     * @description Seed fake customers with random addresses from a region.
     *
     * Creates N customers with Faker-generated names, phone numbers, and emails,
     * using real addresses sampled from the specified region's address file.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const seedCustomersTotal = qraft.adminSeedService.seedCustomers.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const seedCustomersTotal = qraft.adminSeedService.seedCustomers.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SeedCustomersBody,
            SeedCustomersData,
            SeedCustomersParameters,
            OperationError<SeedCustomersError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SeedCustomersSchema,
            SeedCustomersBody,
            SeedCustomersData,
            SeedCustomersParameters,
            OperationError<SeedCustomersError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Seed Customers
     * @description Seed fake customers with random addresses from a region.
     *
     * Creates N customers with Faker-generated names, phone numbers, and emails,
     * using real addresses sampled from the specified region's address file.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const seedCustomersPendingMutationVariables = qraft.adminSeedService.seedCustomers.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const seedCustomersMutationData = qraft.adminSeedService.seedCustomers.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SeedCustomersData,
        OperationError<SeedCustomersError>,
        MutationVariables<SeedCustomersBody, SeedCustomersParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SeedCustomersBody,
            SeedCustomersData,
            SeedCustomersParameters,
            OperationError<SeedCustomersError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SeedCustomersSchema,
            SeedCustomersBody,
            SeedCustomersData,
            SeedCustomersParameters,
            OperationError<SeedCustomersError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SeedCustomersData,
          OperationError<SeedCustomersError>,
          MutationVariables<SeedCustomersBody, SeedCustomersParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Seed Customers
     * @description Seed fake customers with random addresses from a region.
     *
     * Creates N customers with Faker-generated names, phone numbers, and emails,
     * using real addresses sampled from the specified region's address file.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SeedCustomersBody,
            SeedCustomersData,
            SeedCustomersParameters,
            OperationError<SeedCustomersError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SeedCustomersSchema,
            SeedCustomersBody,
            SeedCustomersData,
            SeedCustomersParameters,
            OperationError<SeedCustomersError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Seed Customers
     * @description Seed fake customers with random addresses from a region.
     *
     * Creates N customers with Faker-generated names, phone numbers, and emails,
     * using real addresses sampled from the specified region's address file.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.adminSeedService.seedCustomers.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.adminSeedService.seedCustomers.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SeedCustomersBody,
              SeedCustomersData,
              SeedCustomersParameters,
              OperationError<SeedCustomersError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SeedCustomersSchema,
              SeedCustomersBody,
              SeedCustomersData,
              SeedCustomersParameters,
              OperationError<SeedCustomersError>,
              TContext
            >
      ):
        | Mutation<
            SeedCustomersData,
            SeedCustomersError,
            MutationVariables<SeedCustomersBody, SeedCustomersParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SeedCustomersBody,
              SeedCustomersData,
              SeedCustomersParameters,
              OperationError<SeedCustomersError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SeedCustomersSchema,
              SeedCustomersBody,
              SeedCustomersData,
              SeedCustomersParameters,
              OperationError<SeedCustomersError>,
              TContext
            >
      ): Array<
        Mutation<
          SeedCustomersData,
          SeedCustomersError,
          MutationVariables<SeedCustomersBody, SeedCustomersParameters>,
          TContext
        >
      >;
    };
    schema: SeedCustomersSchema;
    types: {
      parameters: SeedCustomersParameters;
      data: SeedCustomersData;
      error: SeedCustomersError;
      body: SeedCustomersBody;
    };
  };
}
/**
 * @summary Create Seed Service Events
 * @description Bulk seed service events for existing customers.
 *
 * Creates service events for multiple customers, auto-instantiating
 * service types (and optionally service plans) from templates.
 */
export const seedServiceEvents = {
  schema: {
    method: 'post',
    url: '/admin/seed/service_events',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: SeedServiceEventsSchema;
  [QraftServiceOperationsToken]: AdminSeedService['seedServiceEvents'];
};
/**
 * @summary Get Customers With Events
 * @description List customers with optional filtering by upcoming events in date range.
 *
 * Use has_upcoming_events=false to find customers without scheduled events
 * (ideal candidates for seeding).
 */
export const listCustomersWithEvents = {
  schema: {
    method: 'get',
    url: '/admin/seed/customers_with_events',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListCustomersWithEventsSchema;
  [QraftServiceOperationsToken]: AdminSeedService['listCustomersWithEvents'];
};
/**
 * @summary Create Seed Customers
 * @description Seed fake customers with random addresses from a region.
 *
 * Creates N customers with Faker-generated names, phone numbers, and emails,
 * using real addresses sampled from the specified region's address file.
 */
export const seedCustomers = {
  schema: {
    method: 'post',
    url: '/admin/seed/customers',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: SeedCustomersSchema;
  [QraftServiceOperationsToken]: AdminSeedService['seedCustomers'];
};
export const adminSeedService = {
  seedServiceEvents,
  listCustomersWithEvents,
  seedCustomers,
} as const;
type SeedServiceEventsSchema = {
  method: 'post';
  url: '/admin/seed/service_events';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type SeedServiceEventsParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type SeedServiceEventsData =
  paths['/admin/seed/service_events']['post']['responses']['200']['content']['application/json'];
type SeedServiceEventsError =
  paths['/admin/seed/service_events']['post']['responses']['422']['content']['application/json'];
type SeedServiceEventsBody = paths['/admin/seed/service_events']['post']['requestBody']['content']['application/json'];
type ListCustomersWithEventsSchema = {
  method: 'get';
  url: '/admin/seed/customers_with_events';
  security: ['HTTPBearer'];
};
type ListCustomersWithEventsParameters = paths['/admin/seed/customers_with_events']['get']['parameters'];
type ListCustomersWithEventsData =
  paths['/admin/seed/customers_with_events']['get']['responses']['200']['content']['application/json'];
type ListCustomersWithEventsError =
  paths['/admin/seed/customers_with_events']['get']['responses']['422']['content']['application/json'];
type SeedCustomersSchema = {
  method: 'post';
  url: '/admin/seed/customers';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type SeedCustomersParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type SeedCustomersData = paths['/admin/seed/customers']['post']['responses']['200']['content']['application/json'];
type SeedCustomersError = paths['/admin/seed/customers']['post']['responses']['422']['content']['application/json'];
type SeedCustomersBody = paths['/admin/seed/customers']['post']['requestBody']['content']['application/json'];
